import React, { useEffect, useState } from "react";
import db from "./firebase";
import Blog from "./templates/blog/Blog";

function Individual(props) {
  const { title } = props;
  const [articles, setArticles] = useState(undefined);

  useEffect(() => {
    async function getData() {
      let d = new Date();
      let month = parseInt((d.getMonth() + 1).toString());
      let day = d.getDate().toString();
      // let day = "15";
      let year = d.getUTCFullYear().toString();
      return month + day + year;
    }

    async function nextStep() {
      const idSnap = await getData();
      console.log("idSnap:", idSnap);

      const articles = await db.collection(title).doc(idSnap);
      articles
        .get()
        .then(function (doc) {
          if (doc.exists) {
            const newsArticles = doc.data().uniqueResponses;
            console.log("Document data:", doc.data().uniqueResponses);
            setArticles(newsArticles);
          } else {
            console.log("No such document!");
          }
        })
        .catch(function (error) {
          console.log("Error getting document:", error);
        });
      console.log("??", articles);
    }
    nextStep();
  }, [title]);

  if (!articles) return <div>Loading...</div>;
  return (
    <>
      <Blog title={title} articles={articles} />
    </>
  );
}

export default Individual;
